import { ReactNode } from 'react';

import { FormattedMessage } from 'react-intl';

import messages from './OrderSummary.messages';
import styles from './OrderSummary.module.css';
import { RepaymentsSchedule } from './RepaymentsSchedule';
import { FormattedCurrency } from '../../../iwIntlProvider/FormattedCurrency';
import { Rate } from '../../ui/rate/Rate';

const OrderSummary = ({
    title,
    interestRate,
    account
}: {
    title: ReactNode;
    interestRate: number;
    account: any;
}) => {
    return (
        <div className={styles.summary}>
            <h2 className={styles.title}>
                {title ? (
                    title
                ) : (
                    <FormattedMessage {...messages.defaultTitle} />
                )}
            </h2>

            <h3 data-testid="order-amount-title" className={styles.subTitle}>
                <FormattedMessage
                    {...messages.subTitle}
                    values={{
                        amount: (
                            <FormattedCurrency value={account.balance.total} />
                        )
                    }}
                />
            </h3>

            <RepaymentsSchedule account={account} />

            <p data-testid="interest-disclaimer" className={styles.disclaimer}>
                <FormattedMessage
                    {...messages.interestRateDisclaimer}
                    values={{
                        interestRate: <Rate value={interestRate} />
                    }}
                />
            </p>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default OrderSummary;
